import { createTheme, ThemeProvider, ScopedCssBaseline, Box, Icon } from "@mui/material";
import React from "react";
import { MainSite } from "../../MainSite";
import { Table } from "./Components/Table";
import { ColorLegend } from "./Components/ColorLegend";
import { TimeRangeButtons } from "../Components/TimeRangeButtons";

interface Props {
    mainSite: MainSite,
    data: any
}

export function GOMTablePageComponent(props: Props): React.JSX.Element {
    //: READ: https://mui.com/material-ui/react-css-baseline/#scoping-on-children
    //: SEE: https://mui.com/material-ui/react-tabs/#vertical-tabs

        const [timeRange, setTimeRange] = React.useState<"LatestValue" | "Average3h" | "Average24h" >("LatestValue");

    const theme = createTheme({ //: https://mui.com/material-ui/customization/typography/#font-size  +  https://mui.com/material-ui/customization/theme-components/#theme-variables
        typography: {
            fontSize: 20,
        },
    });

        return (
            <>
                <React.StrictMode>
                    <ThemeProvider theme={theme}>
                        <ScopedCssBaseline>
                            <Box
                                className="container"
                                sx={{
                                    bgcolor: 'background.paper',
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}
                            >
                                {/*Show loading or table*/}
                                {(!props.mainSite.liveDataManager.latestData || !props.mainSite.GOMAveragesManager.latestData)
                                    ?
                                    <div className="container">
                                        <table className="table table-striped table-hover midi_tablePage_main_table midi_common_table">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <span className="text-muted">
                                                            <i className="fa fa-spin fa-refresh">
                                                            </i>
                                                            Loading table...
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    :
                                    <>
                                        <Box
                                            sx={{
                                                bgcolor: 'background.paper',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between',
                                                mb: 2
                                            }}
                                        >

                                        <TimeRangeButtons timeRange={timeRange} setTimeRange={setTimeRange} />

                                        <ColorLegend />

                                    </Box>

                                    <Box>
                                        <Table mainSite={props.mainSite} data={props.data} timeRange={timeRange} />
                                    </Box>
                                </>
                            }
                            

                        </Box>
                    </ScopedCssBaseline>
                </ThemeProvider>
            </React.StrictMode>
        </>
    );
}